/* ==========================================================================
   KUL KID — shfw-reveal.js
   1) Scroll-reveal for SHFW sections: elements opt in with [data-shfw-reveal],
      revealed once when they enter the viewport (staggered via --shfw-reveal-i).
   2) Continuous scroll-linked image zoom: containers opt in with
      [data-shfw-zoom]; their inner <img> scales with scroll position.
   Idempotent. Respects prefers-reduced-motion.
   ========================================================================== */
(function () {
  if (window.__shfwRevealInit) return;
  window.__shfwRevealInit = true;

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Reveal ---------------------------------------------------------- */
  function revealAll(root) {
    var els = (root || document).querySelectorAll('[data-shfw-reveal]');
    for (var i = 0; i < els.length; i++) els[i].classList.add('shfw-is-visible');
  }

  function initReveal() {
    if (reduce || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('shfw-is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    function observe() {
      document.querySelectorAll('[data-shfw-reveal]').forEach(function (el) {
        if (!el.__shfwObserved) {
          el.__shfwObserved = true;
          observer.observe(el);
        }
      });
    }
    observe();
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', observe);
    }
  }

  /* ---- 2. Scroll-linked zoom --------------------------------------------- */
  var INTENSITY = 0.18; // max extra scale (18%)

  function zoomTargets() {
    var out = [];
    document.querySelectorAll('[data-shfw-zoom]').forEach(function (el) {
      var imgs = el.tagName === 'IMG'
        ? [el]
        : Array.prototype.slice.call(el.querySelectorAll('img'));
      if (imgs.length) out.push({ box: el, imgs: imgs });
    });
    return out;
  }

  function initZoom() {
    if (reduce) return;
    var targets = zoomTargets();
    if (!targets.length) return;

    var ticking = false;
    function render() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      targets.forEach(function (t) {
        var r = t.box.getBoundingClientRect();
        if (r.bottom < -50 || r.top > vh + 50) return; // offscreen: skip
        var center = r.top + r.height / 2;
        // progress: 0 when the box centre is at the bottom of the viewport,
        // 1 when it reaches the top. Scrolling down zooms in, up zooms out.
        var progress = 1 - center / vh;
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;
        var scale = 1 + progress * INTENSITY;
        var s = 'scale(' + scale.toFixed(4) + ')';
        for (var k = 0; k < t.imgs.length; k++) t.imgs[k].style.transform = s;
      });
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(render);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    render();

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        targets = zoomTargets();
        render();
      });
    }
  }

  /* ---- 3. Crossfade slideshow -------------------------------------------- */
  function initFade() {
    document.querySelectorAll('[data-shfw-fade]').forEach(function (root) {
      if (root.__shfwFadeDone) return;
      root.__shfwFadeDone = true;
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-fade-slide]'));
      if (!slides.length) return;
      // Ensure the first slide is visible even with reduced motion / single image.
      slides[0].classList.add('is-active');
      if (reduce || slides.length < 2) return;
      var interval = parseInt(root.getAttribute('data-fade-interval'), 10) || 4000;
      var i = 0;
      var timer = null;
      function step() {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }
      function start() { stop(); timer = window.setInterval(step, interval); }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      start();
    });
  }

  function init() {
    initReveal();
    initZoom();
    initFade();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
